import React, { type ReactNode } from 'react';

interface ToggleButtonProps {
    children: ReactNode;
    id: string;
    checked: boolean;
    disabled?: boolean;
    hideInput: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>, id: string) => void;
}

export const ToggleButton = (props: ToggleButtonProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(e, props.id);
    };

    const hideCheckbox = props.hideInput;

    return (
        <div className="form-check layer-control__item">
            <input
                type="checkbox"
                className="form-check-input"
                onChange={handleChange}
                checked={props.checked}
                id={'checkbox-toggle-' + props.id}
                disabled={props.disabled}
            />
            <label
                htmlFor={'checkbox-toggle-' + props.id}
                className={'form-check-label layer-control__checkbox-label' + (hideCheckbox ? ' layer-control__checkbox-label--hidden-checkbox' : '')}
            >
                {props.children}
            </label>
        </div>
    );
};
